import { Box, Container, Stack, Typography, Link } from "@mui/material";
import React from "react";
import ArrowRightLink from "../../navigation/ArrowRightLink";
import COLORS from "../../../constants/colors";
import QRButton from "../../QRButton";
import ScrollingPhone from "../../../assets/svgs/phoneScrolling.svg";
import CheckLoanStatusLink from "../../CheckLoanStatusLink";
import { SoknadType } from "../../../constants/soknadType";


const AppGreeterShowcase = () => {
  return (
    <section>
      <Box sx={{ bgcolor: COLORS.BRIGHT_BLUE[60] }} overflow="hidden">
        <Container maxWidth="lg">
          <Stack
            pb={{ xs: "130px", md: "110px", lg: "40px" }}
            pt={{ xs: "24px", md: "56px", lg: "80px" }}
            px={{ xs: "0px", md: "0px" }}
            gap={{ xs: "24px", md: "60px" }}
          >
            <Stack flexDirection="row" position="relative">
              <Stack>
                <Typography
                  color={COLORS.BRIGHT_BLUE[100]}
                  variant="h1Biro"
                  position="relative"
                  top="10px"
                >
                  Vær
                </Typography>
                <Typography
                  variant="h1Large"
                  color={COLORS.DARK_BLUE[100]}
                  whiteSpace={{ xs: "normal", md: "nowrap" }}
                  fontSize={{
                    xs: "68px !important",
                    sm: "90px !important",
                    md: "80px !important",
                    lg: "100px !important",
                  }}
                  component="h1"
                >
                  Sjef i egen økonomi
                </Typography>
              </Stack>

              {/* LARGE SCREEN */}
              <Stack
                display={{
                  xs: "none",
                  md: "flex",
                }}
                position="absolute"
                right="-100px"
                top="80px"
              >
                <Stack position="relative">
                  <ScrollingPhone height="447px" width="471px" />
                  <Stack position="absolute" bottom="20px" left="-200px">
                    <Stack position="absolute" bottom="120px" left="-140px">
                      <Typography
                        color={COLORS.BRIGHT_BLUE[100]}
                        variant="h1Biro"
                        sx={{
                          transform: "rotate(-10deg)",
                          textWrap: "nowrap",
                        }}
                      >
                        Gode økonomiske
                      </Typography>
                    </Stack>
                    <Stack position="absolute" left="5px" bottom="60px">
                      <Typography
                        color={COLORS.BRIGHT_BLUE[100]}
                        variant="h1Biro"
                        sx={{
                          transform: "rotate(-10deg)",
                          textWrap: "nowrap",
                        }}
                      >
                        vaner
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
              {/* MEDIUM SCREEN */}
              <Stack
                display={{
                  xs: "none",
                  sm: "flex",
                  md: "none",
                }}
                position="absolute"
                right="-45px"
                top="200px"
              >
                <Stack position="relative">
                  <ScrollingPhone height="395px" width="331px" />
                  <Stack position="absolute" bottom="100px" left="-45px">
                    <Stack position="absolute" bottom="50px" left="-50px">
                      <Typography
                        color={COLORS.BRIGHT_BLUE[100]}
                        variant="h1Biro"
                        sx={{
                          transform: "rotate(-10deg)",
                          textWrap: "nowrap",
                          fontSize: "36px !important",
                        }}
                      >
                        Gode økonomiske
                      </Typography>
                    </Stack>
                    <Stack position="absolute" left="60px" bottom="0px">
                      <Typography
                        color={COLORS.BRIGHT_BLUE[100]}
                        variant="h1Biro"
                        sx={{
                          transform: "rotate(2.5deg)",
                          textWrap: "nowrap",
                          fontSize: "36px !important",
                        }}
                      >
                        vaner
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
            <Stack display="flex" flexDirection="row" position="relative">
              <Stack gap="52px" alignItems="flex-start" maxWidth="450px">
                <Typography variant="lead" color="primary">
                  Få kontroll og oversikt over gjeld og alle kontoene dine,
                  uavhengig av hvilke banker du har de i.
                </Typography>
                <Stack maxWidth="169px">
                  <QRButton
                    color="light"
                    variant="contained"
                    label="Last ned appen"
                  />
                </Stack>
                
                <Stack pt={{ xs: 15, md: 0 }}>
                  <Stack flexDirection="row" alignItems="center" ml="-8px">
                    <Link>
                    <CheckLoanStatusLink
                      linkText="Søkt lån? Se lånestatus her"
                      type={SoknadType.ConsumerLoan}
                    />
                    <ArrowRightLink />
                    </Link>
                  </Stack>
                </Stack>
              </Stack>

              {/* SMALL SCREEN */}
              <Stack
                display={{
                  xs: "flex",
                  sm: "none",
                }}
                position="absolute"
                right="-30px"
                top="100px"
              >
                <Stack position="relative">
                  <ScrollingPhone height="294px" width="214px" />
                  <Stack position="absolute" bottom="90px" left="-40px">
                    <Stack position="absolute" bottom="30px" left="-60px">
                      <Typography
                        color={COLORS.BRIGHT_BLUE[100]}
                        variant="h1Biro"
                        sx={{
                          transform: "rotate(-10deg)",
                          textWrap: "nowrap",
                          fontSize: "32px !important",
                        }}
                      >
                        Gode økonomiske
                      </Typography>
                    </Stack>
                    <Stack position="absolute" left="40px" bottom="-10px">
                      <Typography
                        color={COLORS.BRIGHT_BLUE[100]}
                        variant="h1Biro"
                        sx={{
                          transform: "rotate(2.5deg)",
                          textWrap: "nowrap",
                          fontSize: "32px !important",
                        }}
                      >
                        vaner
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Container>
      </Box>
    </section>
  );
};
export default AppGreeterShowcase;
